export default class Hamburger {
    constructor() {
        this.hamburger = document.querySelector('.js-hamburger')
        this.nav = document.querySelector('.js-nav-container')
        if (!this.hamburger || !this.nav) return
        this.hamburger.addEventListener('click', () => {
            if (this.hamburger.classList.contains('menu-open')) {
                this.hamburger.classList.remove('menu-open')
                this.nav.classList.remove('mob-nav-open')

                this.openSubmenu = this.nav.querySelector('.js-subMenu.open')
                this.openSubparent = this.nav.querySelector('.js-hasSubmenu.submenu-open')
                if (this.openSubmenu) {
                    this.openSubmenu.classList.remove('open')
                    this.openSubparent.classList.remove('submenu-open')
                }
            } else {
                this.hamburger.classList.add('menu-open')
                this.nav.classList.add('mob-nav-open')
            }
        })
    }
}
